module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9588.32281010.jpg";